/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import { MergedCardTransactionDetailMergedCardTransactionTransactionRecordListInner } from './merged-card-transaction-detail-merged-card-transaction-transaction-record-list-inner';

/**
 * 
 * @export
 * @interface MergedCardTransactionDetailMergedCardTransaction
 */
export interface MergedCardTransactionDetailMergedCardTransaction {
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransactionDetailMergedCardTransaction
     */
    'visaTransactionReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransactionDetailMergedCardTransaction
     */
    'paymentReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransactionDetailMergedCardTransaction
     */
    'merchantName': string;
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransactionDetailMergedCardTransaction
     */
    'merchantNameKana': string;
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransactionDetailMergedCardTransaction
     */
    'merchantNameKanji': string;
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransactionDetailMergedCardTransaction
     */
    'mergedMerchantName': string;
    /**
     * 
     * @type {number}
     * @memberof MergedCardTransactionDetailMergedCardTransaction
     */
    'amount': number;
    /**
     * 
     * @type {number}
     * @memberof MergedCardTransactionDetailMergedCardTransaction
     */
    'amountFx': number;
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransactionDetailMergedCardTransaction
     */
    'currencyCode': string;
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransactionDetailMergedCardTransaction
     */
    'processedAt': string;
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransactionDetailMergedCardTransaction
     */
    'transactionType': MergedCardTransactionDetailMergedCardTransactionTransactionTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof MergedCardTransactionDetailMergedCardTransaction
     */
    'creditSettlement': number;
    /**
     * 
     * @type {Array<MergedCardTransactionDetailMergedCardTransactionTransactionRecordListInner>}
     * @memberof MergedCardTransactionDetailMergedCardTransaction
     */
    'transactionRecordList': Array<MergedCardTransactionDetailMergedCardTransactionTransactionRecordListInner>;
    /**
     * 
     * @type {boolean}
     * @memberof MergedCardTransactionDetailMergedCardTransaction
     */
    'isCleared': boolean;
}

export const MergedCardTransactionDetailMergedCardTransactionTransactionTypeEnum = {
    confirm: 'CONFIRM',
    notConfirm: 'NOT_CONFIRM'
} as const;

export type MergedCardTransactionDetailMergedCardTransactionTransactionTypeEnum = typeof MergedCardTransactionDetailMergedCardTransactionTransactionTypeEnum[keyof typeof MergedCardTransactionDetailMergedCardTransactionTransactionTypeEnum];


